/**
 * Testi italiani della pagina «Permessi» del set (ADR 0041, proposta P1-P16).
 *
 * I testi principali (P8) e gli avvisi (P6) sono quelli approvati dall'utente il
 * 2026-10-09 nella proposta: si cambiano solo con una sua decisione.
 */

/** Testi della pagina dei permessi. */
export const permissions = {
  /** Voce della barra laterale. */
  nav: 'Permessi',
  /** Pulsante nella testata del set. */
  headerButton: 'Permessi',
  /** Titolo della pagina. */
  title: 'Permessi del set',
  /** Che cosa mostra la pagina. */
  description: 'Cosa possono fare gli agenti e le persone di questo set.',
  /** Avviso per lettori ed editor. */
  readOnly: 'Questi permessi li cambia il proprietario del set. Puoi leggerli.',
  /** Avviso per un set archiviato. */
  archived: 'Il set è archiviato: i permessi si leggono soltanto.',
  /** Errore di lettura. */
  loadFailed: 'Permessi non disponibili. Riprova.',
  /** Pulsante dell'errore di lettura. */
  retry: 'Riprova',
  /** Collegamento dalla scheda di un progetto. */
  projectLink: 'Permessi',
  /** Nome accessibile del collegamento dalla scheda di un progetto. */
  projectLinkAccessible: 'Permessi del progetto {{name}}',
  /** Collegamento dalla pagina Membri. */
  fromMembers: 'Ruoli e permessi di tutto il set stanno nella pagina Permessi.',
  /** Pulsante della pagina Membri verso questa pagina. */
  openPage: 'Apri i permessi',

  /** Titoli dei quattro gruppi. */
  groups: {
    /** Persone. */
    people: 'Persone',
    /** Progetti. */
    projects: 'Progetti',
    /** Collegamenti esterni, dentro la scheda del progetto. */
    links: 'Collegamenti esterni',
    /** Limiti fissi. */
    never: 'Cosa gli agenti non fanno mai',
  },

  /** Gruppo «Persone». */
  people: {
    /** Proprietario. */
    owner: 'Proprietario',
    /** Nome accessibile della scelta del ruolo. */
    roleOf: 'Ruolo di {{name}}',
    /** Nome mostrato quando il set non conosce il nome utente. */
    unknownName: 'Utente senza nome',
    /** Nessun membro. */
    empty: 'Nessun membro oltre al proprietario.',
    /** Titolo degli inviti. */
    invitations: 'Inviti in attesa',
    /** Invito scaduto. */
    expired: 'scaduto',
    /** Pulsante per invitare. */
    invite: 'Invita',
    /** Limite del piano raggiunto. */
    limit: 'Hai raggiunto il limite di persone del tuo piano.',
    /** Collegamento al piano. */
    planLink: 'Vedi il piano',
  },

  /** Livelli per progetto (P4). */
  levels: {
    /** Nome accessibile del controllo. */
    label: 'Livello di {{name}}',
    /** Solo lettura. */
    read_only: 'Solo lettura',
    /** Collaboratore. */
    contributor: 'Collaboratore',
    /** Autonomo. */
    autonomous: 'Autonomo',
    /** Personalizzato. */
    custom: 'Personalizzato',
  },
  /** Perché un livello è spento. */
  levelOff: {
    /** Progetto da collaboratore. */
    contributor: 'Non disponibile per un progetto da collaboratore.',
    /** Analisi da approvare. */
    analysis: 'Finché non approvi l’analisi, gli agenti leggono il repository e non scrivono.',
    /** Collegamento che il chiamante non cambia. */
    locked: 'Le regole GitHub di questo progetto le cambia chi ha collegato l’account.',
  },

  /** Riga della modalità sotto il nome del progetto. */
  modes: {
    /** Da zero. */
    greenfield: 'Da zero. Repository nuovo sull’account di institor.',
    /** Collaboratore esterno. */
    contributor: 'Collaboratore esterno. Rami institor/ e pull request.',
    /** Affidamento totale. */
    delegated: 'Affidamento totale.',
  },
  /** Analisi di un progetto in affidamento totale. */
  analysis: {
    /** In attesa. */
    pending: 'L’analisi aspetta la tua approvazione.',
    /** Rifiutata. */
    rejected: 'Analisi rifiutata: gli agenti leggono soltanto.',
    /** Collegamento alla scheda del progetto. */
    open: 'Apri l’analisi',
  },
  /** Progetto di casa dei set di prima. */
  home: 'Progetto di casa del set: resta in scrittura.',

  /** Interruttori e campi (P5). */
  controls: {
    /** Accesso del set. */
    write: 'Gli agenti scrivono nel progetto',
    /** Aiuto dell'accesso. */
    writeHelp: 'Spento, gli agenti leggono i file e non li cambiano.',
    /** Push sul ramo principale. */
    push: 'Push sul ramo principale',
    /** Aiuto. */
    pushHelp: 'Gli agenti pubblicano le modifiche senza pull request.',
    /** Pull request. */
    pullRequests: 'Pull request',
    /** Aiuto. */
    pullRequestsHelp: 'Gli agenti aprono e aggiornano pull request.',
    /** Issue. */
    issues: 'Issue e commenti',
    /** Aiuto. */
    issuesHelp: 'Gli agenti aprono issue e commentano.',
    /** Sezione avanzata. */
    advanced: 'Avanzate',
    /** Prefisso dei rami. */
    prefix: 'Prefisso dei rami',
    /** Aiuto. */
    prefixHelp: 'Gli agenti fanno push solo sui rami che iniziano così. Vuoto: su qualunque ramo.',
    /** Scrittura su Google. */
    googleWrite: 'Google: scrittura',
    /** Aiuto. */
    googleWriteHelp: 'Spento, gli agenti leggono soltanto.',
    /** Limite di progetto Google Cloud. */
    googleProject: 'Limita a un progetto Google Cloud',
    /** Aiuto. */
    googleProjectHelp: 'Vuoto: tutti i progetti visibili da questo account.',
    /** Sito pubblicato. */
    site: 'Sito pubblicato',
    /** Aiuto, con l'indirizzo. */
    siteHelp: 'Gli agenti installano e gestiscono il sito su {{url}}.',
    /** Aiuto senza sito. */
    siteHelpNew: 'Gli agenti installano e gestiscono il sito del progetto.',
    /** Vetrina. */
    showcase: 'Mostra nella vetrina',
    /** Aiuto. */
    showcaseHelp: 'Il nome e l’indirizzo del sito compaiono sulla pagina di institorAI.',
    /** Interruttore spento in attesa dell'analisi. */
    afterApproval: 'Si attiva dopo l’approvazione.',
    /** Push spento per un progetto da collaboratore. */
    contributorPush: 'Un progetto da collaboratore non fa push sul ramo principale: l’opzione c’è ma per ora non si può attivare.',
    /** Collegamento in lettura per un set che legge il progetto. */
    readsOnly: 'Con il progetto in sola lettura gli agenti usano questo account solo per leggere.',
  },

  /** Perché il sito non si pubblica né si toglie. */
  siteBlock: {
    /** Collaboratore. */
    contributor: 'Un progetto da collaboratore non ha un sito.',
    /** Analisi. */
    analysis_not_approved: 'Il sito arriva dopo l’approvazione dell’analisi.',
    /** Sola lettura. */
    read_only_project: 'Con il progetto in sola lettura gli agenti vedono stato e log del sito.',
    /** Progetto di casa. */
    home_project: 'Il sito del progetto di casa si gestisce dalla pagina Progetti.',
  },

  /** Hosting esterno (ADR 0038). */
  external: {
    /** Titolo. */
    title: 'Ambiente esistente',
    /** Ruolo in lettura. */
    reader: 'Ambiente «{{namespace}}»: gli agenti vedono stato e log.',
    /** Ruolo operatore. */
    operator: 'Ambiente «{{namespace}}»: gli agenti riavviano e cambiano le repliche.',
    /** Chi lo cambia. */
    admin: 'Lo cambia un amministratore della piattaforma.',
  },

  /** Collegamenti GitHub e Google. */
  links: {
    /** Nessun collegamento. */
    none: 'Nessun collegamento',
    /** Pulsante per collegare. */
    connect: 'Collega',
    /** Lettura non riuscita. */
    unavailable: 'Collegamenti non disponibili. Riprova più tardi.',
    /** Riga del collegamento. */
    account: '{{provider}}, account {{account}}',
    /** Perché un collegamento è bloccato. */
    locked: {
      /** Connessione di un altro utente. */
      other_owner: 'Lo cambia chi ha collegato questo account {{provider}}.',
      /** Account di institor. */
      platform: 'Lo gestisce l’account di institor: lo cambia un amministratore.',
      /** Connessione di un progetto. */
      project: 'Lo cambia chi amministra il progetto che possiede la connessione.',
    },
  },

  /** Avvisi delle scelte rischiose (P6). */
  warnings: {
    /** Push sul ramo principale. */
    push: 'Gli agenti pubblicano senza revisione. Un errore arriva subito sul ramo principale.',
    /** Google senza limite. */
    googleUnbounded: 'Gli agenti possono modificare tutti i progetti Google Cloud visibili da questo account.',
    /** Prefisso vuoto. */
    prefix: 'Gli agenti possono fare push su qualunque ramo.',
    /** Editor. */
    editor: 'Un editor scrive all’Institore e consuma i token del proprietario.',
    /** Sito tolto. */
    siteOff: 'Il sito e i suoi dati sul cluster vengono cancellati.',
  },

  /** Gruppo fisso «Cosa gli agenti non fanno mai» (P11). */
  never: {
    /** Introduzione. */
    intro: 'Questi limiti valgono per ogni set e non si cambiano.',
    /** Credenziali. */
    credentials: 'Non leggono credenziali, token e configurazione privata del set.',
    /** Rete. */
    internet: 'Non raggiungono internet in modo diretto: GitHub, Google e i pacchetti passano dal proxy, con le regole di questa pagina.',
    /** Chat. */
    chat: 'Non eseguono comandi scritti nella chat: il testo dell’utente è sempre una richiesta, mai un comando.',
    /** Politica. */
    policy: 'Non scavalcano mai la politica dei permessi.',
  },

  /** Pulsanti della pagina (P8). */
  actions: {
    /** Annulla le modifiche. */
    discard: 'Annulla modifiche',
    /** Apre il riepilogo. */
    review: 'Rivedi e salva',
    /** Salva senza scelte rischiose. */
    save: 'Salva',
    /** Salva con scelte rischiose. */
    saveAndGrant: 'Salva e concedi',
    /** Chiude il riepilogo. */
    cancel: 'Annulla',
  },

  /** Riepilogo prima del salvataggio (P7). */
  review: {
    /** Titolo. */
    title: 'Rivedi le modifiche',
    /** Colonna «prima». */
    before: 'Prima',
    /** Colonna «dopo». */
    after: 'Dopo',
    /** Colonna della voce. */
    item: 'Permesso',
    /** Titolo delle scelte rischiose. */
    risky: 'Scelte rischiose',
    /** Etichetta del campo di conferma per togliere un sito. */
    confirmSite: 'Scrivi «{{name}}» per togliere il sito',
    /** Il nome scritto non corrisponde. */
    mismatch: 'Scrivi il nome del progetto esattamente com’è.',
    /** Titolo della sezione delle persone. */
    people: 'Persone',
  },

  /** Valori nelle colonne Prima e Dopo. */
  values: {
    /** Acceso. */
    on: 'Sì',
    /** Spento. */
    off: 'No',
    /** Lettura. */
    read: 'Lettura',
    /** Scrittura. */
    write: 'Scrittura',
    /** Campo vuoto. */
    empty: 'Nessuno',
  },

  /** Nomi brevi delle parti salvate o no. */
  parts: {
    /** Accesso del set. */
    access: 'accesso a {{project}}',
    /** Collegamento. */
    binding: '{{provider}} di {{project}}',
    /** Sito. */
    site: 'sito di {{project}}',
    /** Vetrina. */
    showcase: 'vetrina di {{project}}',
    /** Ruolo. */
    role: 'ruolo di {{name}}',
  },

  /** Esito del salvataggio (P7, P8, P9). */
  result: {
    /** Salvato. */
    saved: 'Permessi salvati. Valgono dal prossimo messaggio.',
    /** Salvato mentre il set lavora. */
    savedWorking: 'Permessi salvati. Valgono quando finisce il lavoro in corso.',
    /** Salvato con restrizioni mentre il set lavora. */
    savedRestricted: 'Permessi salvati. Le restrizioni valgono subito: il lavoro in corso riprende con i permessi nuovi.',
    /** Salvato con il set in pausa. */
    savedAsleep: 'Permessi salvati. Valgono al prossimo avvio del set.',
    /** Errore. */
    failed: 'Permessi non salvati. Riprova.',
    /** Conflitto. */
    conflict: 'Qualcuno ha cambiato questi permessi. Ricarica la pagina e rivedi le modifiche.',
    /** Pulsante del conflitto. */
    reload: 'Ricarica',
    /** Salvataggio a metà. */
    partial: 'Permessi salvati in parte. Riprova per le parti mancanti.',
    /** Parti salvate. */
    savedParts: 'Salvate: {{parts}}.',
    /** Parti non salvate. */
    unsavedParts: 'Non salvate: {{parts}}.',
    /** Modifiche in sospeso. */
    pending: 'Hai modifiche non salvate.',
  },
};

/** Forma dei testi della pagina dei permessi. */
export type Permissions = typeof permissions;
